import axios from "axios";
import { API_URL } from "../../../core/config/env";
import { getHeaders, processError } from "../../../core/helpers/service-helper";

export const selectTemas = async () => {
    try {
        const resp = await axios.get(
            `${API_URL}/reservas/temas/select`,
            { headers: getHeaders() }
        );

        return resp.data;
    } catch (error) {
        return processError(error);
    }
};
